/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.1.0
 */

import { FreshAsphalt, FreshAsphalt50 } from './palette';

export const tooltipTextColor = FreshAsphalt;
export const tooltipTextColorSecondary = FreshAsphalt50;
